/**
 * @module lib/commercial/ad-security/confiant
 * @see https://www.confiant.com/
 */
import loadScript from "utils/load-script";
import logger from "utils/logger";

const debugTag = "[AD-SECURITY-CONFIANT]";

export default function initConfiant() {
  // Wrapper for The Globe and Mail, generated on 2019-03-06
  var w = window;
  var h = "confiant-integrations.global.ssl.fastly.net";
  var p = "hljCI0zHoD_vRE1cDUCBspfKb0s";
  w.confiant = w.confiant || {};
  w.confiant.callback = () => {
    // Available arguments: blockingType, blockingId, isBlocked, wrapperId, tagId, impressionData
    logger.info(`${debugTag} Malicious ad has been blocked`, arguments);
  };
  return loadScript(`//${h}/${p}/gpt_and_prebid/config.js`);
};
